import { useTranslation } from 'react-i18next';

const FamilyBuildingAdoptionJourney = ({ prevStep, handleChange, formData, nextStep,error,step, totalSteps, isHighmarkPortal }) => {
  const { t } = useTranslation();

  return (
    <>
      <div className="step-section">
        <div className="adoption-journey-label">Adoption Journey</div>
        <h3 className="page-heading-secondary-black-500 mb-5">Where are you in your adoption journey?</h3>
        
        <div className="mb-3 form-check multi-step-form-rdb-chekcbox-wrapper">
          <input
            type="radio"
            className="form-check-input radio-btn win-form-check-input"
            name="AdoptionJourney"
            id="adoptionJourney1"
            value="Exploring Options"
            checked={formData.AdoptionJourney === "Exploring Options"}
            onChange={handleChange}
          />
          <label htmlFor="adoptionJourney1" className="multistep-form-radio-checkbox-label">Exploring Options</label>
        </div>

        <div className="mb-3 form-check multi-step-form-rdb-chekcbox-wrapper">
          <input
            type="radio"
            className="form-check-input radio-btn win-form-check-input"
            name="AdoptionJourney"
            id="adoptionJourney2"
            value="Researching agencies"
            checked={formData.AdoptionJourney === "Researching agencies"}
            onChange={handleChange}
          />
          <label htmlFor="adoptionJourney2" className="multistep-form-radio-checkbox-label">Researching agencies</label>
        </div>

        <div className="mb-3 form-check multi-step-form-rdb-chekcbox-wrapper">
          <input
            type="radio"
            className="form-check-input radio-btn win-form-check-input"
            name="AdoptionJourney"
            id="adoptionJourney3"
            value="Matched with an expectant parent"
            checked={formData.AdoptionJourney === "Matched with an expectant parent"}
            onChange={handleChange}
          />
          <label htmlFor="adoptionJourney3" className="multistep-form-radio-checkbox-label">Matched with an expectant parent</label>
        </div>

        <div className="mb-3 form-check multi-step-form-rdb-chekcbox-wrapper">
          <input
            type="radio"
            className="form-check-input radio-btn win-form-check-input"
            name="AdoptionJourney"
            id="adoptionJourney4"
            value="In legal / placement process"
            checked={formData.AdoptionJourney === "In legal / placement process"}
            onChange={handleChange}
          />
          <label htmlFor="adoptionJourney4" className="multistep-form-radio-checkbox-label">In legal / placement process</label>
        </div>

        <div className="mb-3 form-check multi-step-form-rdb-chekcbox-wrapper">
          <input
            type="radio"
            className="form-check-input radio-btn win-form-check-input"
            name="AdoptionJourney"
            id="adoptionJourney5"
            value="Post-placement / post-adoption"
            checked={formData.AdoptionJourney === "Post-placement / post-adoption"}
            onChange={handleChange}
          />
          <label htmlFor="adoptionJourney5" className="multistep-form-radio-checkbox-label">Post-placement / post-adoption</label>
        </div>
        {error && <p className="text-danger">{error}</p>}
        {/* Navigation Buttons */}
        <div className="mt-5">
    {isHighmarkPortal ? (
    <div className="pagination-wrapper mt-5">
      <button className="previous-btn" onClick={prevStep}></button>
      <span className="me-3">{step} of {totalSteps}</span>
      <button className="next-btn" onClick={nextStep}></button>
    </div>
  ) : (
    <>
      <button className="win-btn-secondary mobile-view me-3 mb-2 mb-md-0" onClick={prevStep}>
        {t('back')}
      </button>
      <button className="win-btn-primary mobile-view mb-3" onClick={nextStep}>{t('next')}</button>
    </>
  )}
</div>

      </div>
    </>
  );
};

export default FamilyBuildingAdoptionJourney;
